import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

import { INPUT_1_CLASS, INPUT_2_CLASS, addClassName, checkFormatValueSlice, sliceValue } from './index.utils';
import { checkIsNull } from '../../Utils/utils';
import { fieldShape } from './index.shape';

import './index.scss';

/**
 * text field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const InputSsnCommon = ({ field: { name, value }, placeholder, disabled, existError, showError, eventEmitter }) => {
  const [localValue1, setLocalValue1] = useState(sliceValue(value, 0, 13));
  const [localValue2, setLocalValue2] = useState(sliceValue(value, 13, 15));

  // observalbe value
  useEffect(
    () => {
      setLocalValue1(sliceValue(value, 0, 13));
      setLocalValue2(sliceValue(value, 13, 15));
    },
    //
    [value]
  );

  // observable localvalue1 and/or localvalue2
  const onBlur = () => {
    let result;
    // local value 1
    if (!checkIsNull(localValue1)) {
      result = `${localValue1}`;
    }
    // local value 2
    if (!checkIsNull(localValue2)) {
      result += localValue2;
    }
    eventEmitter(result);
  };

  return (
    <div style={{ flexWrap: 'nowrap', display: 'flex' }}>
      <input
        className={addClassName({ inputClass: INPUT_1_CLASS, existError, showError })}
        name={`${name}_1`}
        placeholder={placeholder}
        value={localValue1 || ''}
        disabled={disabled}
        onBlur={onBlur}
        onChange={e => setLocalValue1(checkFormatValueSlice(get(e, 'target.value'), 13))}
      />
      <input
        className={addClassName({ inputClass: INPUT_2_CLASS, existError, showError })}
        name={`${name}_2`}
        value={localValue2 || ''}
        disabled={disabled}
        onBlur={onBlur}
        onChange={e => setLocalValue2(checkFormatValueSlice(get(e, 'target.value'), 2))}
      />
    </div>
  );
};

InputSsnCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  eventEmitter: PropTypes.func.isRequired,
};

InputSsnCommon.defaultProps = {
  field: {
    value: undefined,
  },
  disabled: false,
  placeholder: '',
};

export default InputSsnCommon;
